import { all, call, fork, takeEvery } from 'redux-saga/effects';

import { createLogger } from '../../../helpers/loggerFacade';
import { actualizeTeleMessengerUrlAction, checkHasDesktopAppAction, setDesktopAppPromoClosed } from '../index';
import { checkCreatedWithReload } from './check-created-with-reload';
import { checkDesktopAppSaga } from './check-desktop-app';
import setDesktopAppPromoClosedSaga from './set-desktop-app-promo-closed';
import setWebRtcCapabilities from './set-web-rtc-capabilities';
import { actualizeTeleMessengerRedirectSaga, teleMessengerRedirectSaga } from './telemessenger-redirect';

export const logger = createLogger('config-sagas');

/**
 *
 */
export default function* (): Generator {
    yield call(checkCreatedWithReload);

    yield all([
        call(setWebRtcCapabilities),
        fork(teleMessengerRedirectSaga),
        takeEvery(actualizeTeleMessengerUrlAction, actualizeTeleMessengerRedirectSaga),
        takeEvery(checkHasDesktopAppAction.type, checkDesktopAppSaga),
        takeEvery(setDesktopAppPromoClosed.type, setDesktopAppPromoClosedSaga),
    ]);
}

export * from './cookie';
